import {
  FleetVehicleServiceEditFormValues,
  FleetVehicleServiceSearchFormValues,
  VehicleServiceStatusEnum,
} from "./types";

export const initialFleetVehicleServiceSearchForm: FleetVehicleServiceSearchFormValues =
  {
    search: "",
    vehicleServiceStatusId: null,
    contactId: null,
    vehicleManufacturerId: null,
    vehicleModelId: null,
    vehicleTypeId: null,
    receivedDateFrom: null,
    receivedDateTo: null,
    isOpen: null,
  };

/**
 * Novi nalog kreće od "Zaprimljeno" — otvara se u trenutku kad vozilo odlazi na servis,
 * a datum zaprimanja je tada današnji dan.
 */
export const initialFleetVehicleServiceEditForm: FleetVehicleServiceEditFormValues =
  {
    id: "",
    vehicleServiceStatusId: VehicleServiceStatusEnum.RECEIVED,
    contactId: null,
    name: "",
    description: "",
    receivedDate: null,
    expectedDate: null,
    completedDate: null,
    kmTraveled: null,
    damageIds: [],
    documentUploads: [],
  };
